export function getCookie(cname: string) {
  var decodedCookie = decodeURIComponent(document.cookie);
  let cookie = undefined;
  decodedCookie
    .split(";")
    .map((ck) => ck.trim())
    .forEach((ck) => {
      let [ckKey, ckValue] = ck.split("=");
      if (ckKey === cname) cookie = ckValue;
    });

  return cookie;
}
export function setCookie(
  cname: string,
  cvalue: string,
  exdays: number | null,
  domainLevel = null
) {
  var d = new Date();
  if (exdays !== null) {
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var cookieOptions: any = {
      [cname]: cvalue,
      expires: d.toUTCString(),
      path: "/",
    };
  } else {
    var cookieOptions: any = {
      [cname]: cvalue,
      path: "/",
    };
  }

  if (domainLevel) cookieOptions.domain = domainLevel;
  var cookie = Object.keys(cookieOptions)
    .map((key) => `${key}=${cookieOptions[key]}`)
    .join(";");
  document.cookie = cookie;
}

export function clearCookie(cname: string) {
  setCookie(cname, "", -1);
}
